import { compose, createStore } from 'redux';
import { middlewares } from './enhancers';
import reducers from './reducers';
import rootSaga from './sagas';
import { sagaMiddleware } from './enhancers/middlewares';

const customComposer =
  (process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const enhancers = customComposer(middlewares);

const store = createStore(reducers, enhancers);

sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./redux/store.js